import BoltIcon from '@mui/icons-material/Bolt';
import SellIcon from '@mui/icons-material/Sell';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { NFTCollection, NFTDetails } from '@psychedelic/dab-js';
import { useEffect, useState } from 'react';
import { BsShieldLockFill } from 'react-icons/bs';

import { Cards } from 'Components/Cards';

export const Collection = ({
	collection,
	isLastCollection
}: {
	collection: NFTCollection;
	isLastCollection: boolean;
}) => {
	return (
		<Box
			sx={{
				width: '100%'
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column'
				}}
			>
				<Typography gutterBottom variant='h5' fontWeight='bold'>
					{collection.name}
				</Typography>
				<Typography gutterBottom variant='caption'>
					{collection.description}
				</Typography>
				<Cards>
					{collection.tokens.map((token, idx) => (
						<Token key={idx} token={token} />
					))}
				</Cards>
			</Box>
			{!isLastCollection ? (
				<Divider
					sx={{
						marginTop: 1.5
					}}
				/>
			) : null}
		</Box>
	);
};

const Token = ({ token }: { token: NFTDetails }) => {
	const [nftType, setNftType] = useState('');

	useEffect(() => {
		const init = async () => {
			const response = await fetch(token.url);
			const asset = await response.blob();

			setNftType(asset.type);
		};

		init();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const CardMediaComponent = () => {
		if (!nftType) {
			return null;
		}

		if (nftType.includes('image')) {
			return (
				<CardMedia
					component='img'
					image={token.url}
					alt={token.name}
					height='360'
					width='100%'
					loading='lazy'
					sx={{
						backgroundColor: 'action.active',
						'&:hover': {
							cursor: 'pointer'
						}
					}}
					onClick={() => window.open(token.url, '_blank')}
				/>
			);
		}

		if (nftType.includes('video')) {
			return (
				<CardMedia
					component='video'
					image={token.url}
					title={token.name}
					controls
					height='360'
					width='100%'
					sx={{
						backgroundColor: 'action.active',
						'&:hover': {
							cursor: 'pointer'
						},
						objectFit: 'cover'
					}}
				/>
			);
		}

		if (nftType.includes('html')) {
			return (
				<CardMedia
					component='iframe'
					src={token.url}
					title={token.name}
					height='360'
					width='100%'
					loading='lazy'
					frameBorder='0'
					sx={{
						backgroundColor: 'action.active',
						'&:hover': {
							cursor: 'pointer'
						}
					}}
				/>
			);
		}

		return null;
	};

	return (
		<Grid key={token.id} item xs={6} sm={6} md={3}>
			<Card
				elevation={4}
				sx={{
					'&:hover': {
						boxShadow: 10
					}
				}}
			>
				<CardMediaComponent />
				<CardActions>
					<Button
						startIcon={<SellIcon />}
						variant='contained'
						sx={{
							flexGrow: 1
						}}
					>
						Sell
					</Button>
					<Button variant='outlined' startIcon={<BsShieldLockFill />}>
						Stake
					</Button>
					<Button variant='outlined' startIcon={<BoltIcon />}>
						Zap
					</Button>
				</CardActions>
			</Card>
		</Grid>
	);
};
